import { Component, OnInit } from "@angular/core"
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms"
import { REFERENTIAL, ReferentialDTO, ReferentialService } from "@app/pages/referential/referential.service"
import { ActivatedRoute, Router } from "@angular/router"
import { NotifService } from "@shared/service/notif.service"
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog"
import { showFormErrors } from "@shared/util/form.util"
import { TableHeader } from "@shared/component/list/list.model"
import { ListViewService } from "@shared/component/views-list/list-views.service"
import { FireStoreService } from "@shared/service/fire-store.service"

@Component({
  selector: "app-referential-edit",
  templateUrl: "./referential-edit.component.html",
  styleUrls: ["./referential-edit.component.scss"],
})
export class ReferentialEditComponent implements OnInit {
  form!: UntypedFormGroup
  referential?: ReferentialDTO
  processing = false
  fields: Array<TableHeader> = []
  views: Array<{ label: string; value: string }> = []
  refValues: { [referential: string]: Array<ReferentialDTO> } = {} // valeurs des champs de type "referential"
  protected readonly REFERENTIAL = REFERENTIAL

  constructor(
    private route: ActivatedRoute,
    private referentialService: ReferentialService,
    private formBuilder: UntypedFormBuilder,
    private notifService: NotifService,
    private router: Router,
    private dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    public refService: ReferentialService,
    public listViewService: ListViewService
  ) {}

  // ouverte hors de l'écran des référentiels : service du référentiel édité, sans changer le service global
  private get store(): FireStoreService<ReferentialDTO> {
    return this.dialogConfig.data?.service || this.referentialService.fireStoreService
  }

  async ngOnInit() {
    this.referential = this.dialogConfig.data?.referential
    this.fields = this.dialogConfig.data?.fields

    const config = {
      name: [undefined, [Validators.required]],
    }
    this.fields.forEach((field) => {
      if (!config[field.field]) {
        config[field.field] = field.field === "color" ? ["black", undefined] : [undefined, undefined]
      }
    })
    this.form = this.formBuilder.group(config)

    if (this.referential?.id) {
      this.store.get(this.referential.id).then((referential) => {
        this.referential = referential
        const patch = {}
        for (const key in referential) {
          if (key !== "id") {
            patch[key] = this.referential[key]
          }
        }
        this.form.patchValue(patch)
      })
    }

    this.fields
      .filter((field) => field.type === "referential" && field.referential)
      .forEach((field) => {
        const key = field.referential as REFERENTIAL
        this.referentialService.getAllFromCache(key).then((values) => (this.refValues[key] = values))
      })

    if (this.fields.some((field) => field.type === "refView")) {
      this.listViewService.setViewKey("performances")
      const views = await this.listViewService.getAllFromCache()
      this.views = views.map((v) => ({ label: v.name, value: v.id }))
    }
  }

  save() {
    if (this.processing) {
      return
    }
    if (this.form.valid) {
      this.processing = true
      if (this.referential?.id) {
        this.store
          .update({
            id: this.referential.id,
            ...this.form.value,
          })
          .then((referential) => {
            this.notifService.displaySuccess("Element mis à jour")
            this.dialogRef.close(referential)
          })
          .finally(() => (this.processing = false))
      } else {
        this.store
          .create(this.form.value, this.formatToUniqueKey(this.form.value.name))
          .then((referential) => {
            if (referential) {
              this.dialogRef.close(referential)
            }
          })
          .finally(() => (this.processing = false))
      }
    } else {
      showFormErrors(this.form)
    }
  }

  formatToUniqueKey(str: string): string {
    return str
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") //Removing accent
      .replace(/[ \/]/g, "_")
  }
}
